/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query"
import { queryOptions, useQuery } from "@tanstack/react-query"

import fetch from "~/backend/axiosClient"
import type {
  RequestConfig,
  ResponseErrorConfig,
  ResponseConfig,
} from "~/backend/axiosClient"

import type {
  GetDesignTokensQueryResponse,
  GetDesignTokensPathParams,
} from "../types/GetDesignTokens.ts"

export const getDesignTokensQueryKey = (
  productSheetGroupId: GetDesignTokensPathParams["productSheetGroupId"]
) =>
  [
    {
      url: "/v1/organization-settings/get-design-tokens/:productSheetGroupId",
      params: { productSheetGroupId },
    },
  ] as const

export type GetDesignTokensQueryKey = ReturnType<typeof getDesignTokensQueryKey>

/**
 * @summary Get design tokens by productSheetGroupId
 * {@link /v1/organization-settings/get-design-tokens/:productSheetGroupId}
 */
export async function getDesignTokens(
  productSheetGroupId: GetDesignTokensPathParams["productSheetGroupId"],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const res = await request<
    GetDesignTokensQueryResponse,
    ResponseErrorConfig<Error>,
    unknown
  >({
    method: "GET",
    url: `/v1/organization-settings/get-design-tokens/${productSheetGroupId}`,
    ...requestConfig,
  })
  return res
}

export function getDesignTokensQueryOptions(
  productSheetGroupId: GetDesignTokensPathParams["productSheetGroupId"],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {}
) {
  const queryKey = getDesignTokensQueryKey(productSheetGroupId)
  return queryOptions<
    ResponseConfig<GetDesignTokensQueryResponse>,
    ResponseErrorConfig<Error>,
    ResponseConfig<GetDesignTokensQueryResponse>,
    typeof queryKey
  >({
    enabled: !!productSheetGroupId,
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal
      return getDesignTokens(productSheetGroupId, config)
    },
  })
}

/**
 * @summary Get design tokens by productSheetGroupId
 * {@link /v1/organization-settings/get-design-tokens/:productSheetGroupId}
 */
export function useGetDesignTokens<
  TData = ResponseConfig<GetDesignTokensQueryResponse>,
  TQueryData = ResponseConfig<GetDesignTokensQueryResponse>,
  TQueryKey extends QueryKey = GetDesignTokensQueryKey,
>(
  productSheetGroupId: GetDesignTokensPathParams["productSheetGroupId"],
  options: {
    query?: Partial<
      QueryObserverOptions<
        ResponseConfig<GetDesignTokensQueryResponse>,
        ResponseErrorConfig<Error>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient }
    client?: Partial<RequestConfig> & { client?: typeof fetch }
  } = {}
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...queryOptions } = queryConfig
  const queryKey =
    queryOptions?.queryKey ?? getDesignTokensQueryKey(productSheetGroupId)

  const query = useQuery(
    {
      ...getDesignTokensQueryOptions(productSheetGroupId, config),
      queryKey,
      ...queryOptions,
    } as unknown as QueryObserverOptions,
    queryClient
  ) as UseQueryResult<TData, ResponseErrorConfig<Error>> & {
    queryKey: TQueryKey
  }

  query.queryKey = queryKey as TQueryKey

  return query
}
